import { CaTranslationLoader } from '@core/translation';
import { provideDateFnsAdapter } from '@shared/date-time-picker';
import { APP_INITIALIZERS } from '@core/init/app-initializers';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { interceptors } from '@core/init/interceptors';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  matGlobalRippleConfig, PU_CONFIG, PU_TOAST_CONFIG, TranslateLoaderService,
} from '@pin-up-global/common';
import { IconModule } from '@core/icon';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { environment } from '@environment';
import { TOAST_CONFIG } from '@core/toast';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const COMMON_PROVIDERS = [
  APP_INITIALIZERS,
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideAnimations(),
  provideHttpClient(withInterceptors(interceptors)),
  provideEnvironmentNgxMask(),
  provideDateFnsAdapter(),
  importProvidersFrom(
      NgxPermissionsModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: CaTranslationLoader,
          deps: [HttpClient],
        },
      }),
      IconModule,
  ),
  {
    provide: MAT_RIPPLE_GLOBAL_OPTIONS,
    useValue: matGlobalRippleConfig,
  },
  {
    provide: PU_CONFIG,
    useValue: { useNewIcons: true, apiHost: environment.apiHost },
  },
  {
    provide: PU_TOAST_CONFIG,
    useValue: TOAST_CONFIG,
  },
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      appearance: 'outline',
    },
  },
];
